import React from "react";
import { toast } from 'react-toastify';
import { Card, CardBody, Row, Col } from "reactstrap";
import { BeatLoader } from 'react-spinners';
import { confirm } from '../common/modals/confirmService';
import paymentService from "../../services/paymentService";
import organizationService from "../../services/organizationService";
import PageTitle from "../common/PageTitle";
import AddMinutes from "./modals/addMinutes";
import PlanPayment from "./modals/payment";
import Steper from "../common/steper";

export default class Plan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      plans: [],
      organization: {},
      showModalMinut: false,
      showModalPayment: false,
      error: null,
      activeClass: '',
      loading: true,
      showBtn: null

    };
    this.options = {
      hideProgressBar: true,
    };

    this.getPlanName = this.getPlanName.bind(this);
    this.cancelPlan = this.cancelPlan.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleShowModalMinut = this.handleShowModalMinut.bind(this);
    this.handleSubmitMinute = this.handleSubmitMinute.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleShowModalPayment = this.handleShowModalPayment.bind(this);
    this.handleSubmitPayment = this.handleSubmitPayment.bind(this);
    this.isChecked = this.isChecked.bind(this);
  }

  componentDidMount() {
    this.loadOrganizationById()
    this.loadPlans();
  }

  loadOrganizationById() {
    organizationService.getById(this.state.id).then(result => {
      this.setState({
        organization: result,
        name: result.name,
        activeClass: result.subscription ? result.subscription.planId : null

      })
    }).catch(error => {
      toast.error("Error loading organization", this.options)
    });
  }

  loadPlans() {
    paymentService.getRatePlans()
      .then(result => {
        this.setState({
          loading: false,
          plans: result.plans
        });
      })
      .catch(error => {
      });
  }

  getPlanName(planId) {
    let plans = this.state.plans;
    if (plans.length > 0) {
      let planName = plans.filter(element => {
        return element.id === planId
      })
      return planName[0].name
    }
  }

  cancelPlan() {
    confirm('Are you sure you want to cancel current plan?').then(() => {
      paymentService.cancelPurchase(this.state.organization.subscription.id, this.state.organization, null)
        .then(result => {
          toast.success("Package is successfully cancaled!", this.options);
        })
        .catch(error => {
          toast.error(error.response, this.options)
        });
    }, () => {
    });
  }

  handleChange = event => {
    const target = event.target;
    let organization = this.state.organization;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (this.state.organization.subscription) {
      if (name === 'planId') {
        organization.subscription.planId = value
      }
    }
    this.setState({
      [name]: value,
      activeClass: value,
      error: null,
      organization: organization,
      showBtn: value
    });
  };

  isChecked = (planId) => {
    if (this.state.organization.subscription) {
      return planId === this.state.organization.subscription.planId
    }

  }
  handleShowModalMinut() {
    this.setState({
      showModalMinut: true
    });
  }

  handleClose() {
    if (this.state.showModalMinut) {
      this.setState({ showModalMinut: false });
    } else if (this.state.showModalPayment) {
      this.setState({ showModalPayment: false });
    }
  }

  handleSubmitMinute(data) {
    paymentService.purchaseExtraMinutes(this.state.organization._id, data.nonce, data.minuteId).then(response => {
      this.handleClose();
      toast.success("Extra minutes are successfully purchased!", this.options);
      this.props.history.push("/dashboard/organizations");
    }).catch(error => {
      toast.error(error.response, this.options)
    })
  }

  handleShowModalPayment() {
    if (this.isValid()) {
      this.setState({
        showModalPayment: true,
      });
    } else {
      this.setState({
        error: 'You must select plan!'
      });
    }
  }

  isValid() {
    return this.state.planId
  }

  handleSubmitPayment(data) {
    paymentService.purchase(this.state.organization._id, data.nonce, this.state.planId, data.subscribe).then(response => {
      this.handleClose();
      toast.success("Package is successfully purchased!", this.options);
      if (!this.state.organization.device) {
        this.props.history.push({
          pathname: "/dashboard/payment/" + this.state.organization._id,
          state: { detail: this.state.organization }
        })
      } else {
        this.props.history.push("/dashboard/organizations");
      }

    }).catch(error => {
      this.handleClose();
      toast.error(error.response, this.options)
    })
  }

  render() {
    const { organization, planId, plans, showModalMinut, showModalPayment, showBtn, error } = this.state;
    return (
      <div>
        {showModalMinut ? <AddMinutes show={showModalMinut} handleClose={this.handleClose} handleSubmitMinute={this.handleSubmitMinute} /> : null}
        {showModalPayment ? <PlanPayment show={showModalPayment} handleClose={this.handleClose} handleSubmitPayment={this.handleSubmitPayment} planId={planId} plans={plans} /> : null}

        <div className="curent-plan">
          {organization.subscription ?
            <Row noGutters className="page-header py-4">
              <PageTitle title={`Current plan: ${organization.subscription.planId}`} subtitle="Subscription plan management" className="text-sm-left" />
              <Row className="curent-plan-options">
                <Col sm="12" lg="6">
                  <div className="subtitle-border-bottom h-100">
                    <ul>
                      <li><p>Selected organization</p> <span> {organization.name}</span></li>
                      <li><p>Automatic billing</p> <span>{organization.subscription.neverExpires ? 'ON' : 'OFF'}</span></li>
                      <li><p>Available call credits</p> <span>{organization.limit !== 0 ? organization.limit / 60 : organization.limit}</span></li>
                      <li><p>Additional call credits</p> <span>{organization.extraLimit !== 0 ? organization.extraLimit / 60 : organization.extraLimit}</span></li>
                      <li><p>Expiration date </p><span>{!organization.subscription.neverExpires ? organization.subscription.firstBillingDate : 'N/A'}</span></li>
                      <li><p>VoIP Number</p> <span>{organization.device && organization.device.number && organization.device.number.number ? organization.device.number.number : 'N/A'}</span></li>
                    </ul>
                  </div>
                </Col>
                <Col sm="12" lg="6">
                  <div className="curent-plan-right">
                    <div className="">
                      <button className="btn btn-lightblue" onClick={this.cancelPlan}>Cancel subscription</button>
                      <p>
                        You can still use the same service until expiration date. If you want to keep the VoIP number assigned to the subscription, then you will be required to at least subscribe to the GCP Starter Kit Plan at $0.99/month.
                  </p>
                      < hr />
                    </div>
                    <div className="">
                      <button className="btn btn-lightblue" onClick={this.handleShowModalMinut}>Buy additional call credits</button>
                      <p >
                        Add more call credits to your existing plan. This action will not affect your subscription plan.  It simply adds additional call credits to your current call credit balance.  Additional call credits expire at the same time the subscribed service plan expires.
                  </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Row> :
            <div>
              <Row noGutters className="page-header pt-4">
                <PageTitle title="Purchase a plan" subtitle="Subscription" className="text-sm-left" />
                <Col sm="12" md="12" lg="8" xl="6">
                  <p className="m-0 light-grey">
                    Associate a purchase plan with your organization. Purchased plan and minutes will be applicable only for this organization.
              </p>
                </Col>
              </Row>
              <Steper step={2} />
            </div>
          }
        </div>

        {organization.subscription ? <h3 className="mb-3">Change your subscription plan for organization </h3> : null}
        <div className="form-organization">
          <input className="custom-checkbox" type="checkbox" name="subscribe" id="subscribe" onChange={this.handleChange} />
          <label htmlFor="subscribe" className="m-0"> Automatic billing</label>
          <p className="small">
            By selecting “Automatic Billing”, your selected subscription plan will automatically renew every 30 days.
              </p>
        </div>
        {this.state.loading ?
          <div className=" mb-5">
            <Row noGutters>
              <Col sm="12" md="12" lg="8" xl="6">
                <BeatLoader
                  // css={override}
                  sizeUnit={"px"}
                  size={15}
                  color={'#299bff'}
                  loading={this.state.loading}
                />
              </Col>
            </Row>
          </div> : null}
        {plans.map((plan, i) =>
          <Row noGutters key={plan.id}>
            <Col sm="12" md="12" lg="8" xl="6">
              <Card className={this.state.activeClass === plan.id ? 'active-plan-card card-custom card-plan plan-cards-box box-shadow-no border-gray' : 'card-custom card-plan plan-cards-box box-shadow-no border-gray'}>
                <CardBody>
                  <div className="plan-card-box">
                    <div className="plan-card-name">
                      <span>{plan.id}</span>
                    </div>
                    <div className="plan-card-desc">
                      <div>
                        <h6>{plan.name} <span className="lightblue">{plan.price}$</span></h6>
                        <p className="m-0"> {plan.description}</p>
                      </div>
                      <div className="custom-radio-container">
                        <input
                          id={`sel-${plan.id}`}
                          type="radio"
                          value={plan.id}
                          name="planId"
                          checked={this.isChecked(plan.id)}
                          className="custom-radio"
                          onChange={this.handleChange}
                        />
                        <label htmlFor={`sel-${plan.id}`}> </label>
                        <div className="check"><div className="inside"></div></div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              {showBtn === plan.id ?
                <div className="text-center">
                  <button className="btn btn-lightblue btn-pay-fixed" onClick={this.handleShowModalPayment}>Proceed to payment</button>
                </div> : null
              }
            </Col>
          </Row>
        )}
        {error &&
          <div className={'alert alert-danger'}>{error}</div>
        }
        {/* {!this.state.loading ?
          <Row noGutters>
            <Col sm="12" md="12" lg="8" xl="6">
              <div className="pull-right">
                <button className="btn btn-purple" onClick={this.handleShowModalPayment}>Proceed to payment</button>
              </div>
            </Col>
          </Row> : null} */}


      </div>
    );
  }
}

Plan.propTypes = {
}



// WEBPACK FOOTER //
// ./src/components/planComponent/plan.js